"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARIABLE_CONFIG = exports.VARIABLE_VALUE_MAP = void 0;
exports.VARIABLE_VALUE_MAP = {
    inviteCode: 'InviteCode'
};
exports.VARIABLE_CONFIG = [{ name: exports.VARIABLE_VALUE_MAP.inviteCode, value: '', label: '邀请码' }];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGtCQUFrQixHQUFHO0lBQzlCLFVBQVUsRUFBRSxZQUFZO0NBQzNCLENBQUM7QUFFVyxRQUFBLGVBQWUsR0FBRyxDQUFDLEVBQUUsSUFBSSxFQUFFLDBCQUFrQixDQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDIn0=